module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "3pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("First published in 2009 by")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Red Wheel/Weiser, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("LLC")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("With offices at:")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("500 Third Street, Suite 230")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("San Francisco, CA 94107")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_c('a', {
    attrs: {
      "href": "http://www.redwheelweiser.com",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("www.redwheelweiser.com")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Copyright © 2009 by Raymond Buckland")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without permission in writing from Red Wheel/Weiser, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("LLC")]), _vm._v(". Reviewers may quote brief passages.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("ISBN: 978-1-57863-451-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data available upon request.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Typeset in Adobe Jenson and Priori Sans")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Cover photographs © "), _c('a', {
    attrs: {
      "href": "http://istockphoto.com",
      "target": "_blank"
    }
  }, [_vm._v("istockphoto.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Cover illustrations © Anne Brush")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Original illustrations on pages 8, 23, 30, 36, 40, 47, 60, 68, 75, 80, 94, 98, 107, 110, 114, 119, 124, 139, 140 and 161 © 2009 by Anne Brush")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Illustrations on pages 65, 66, 104, 129, 135, 164 and 165 © Miss Mary")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Illustration on pages 87 © Pepin Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Photographs on pages 11, 59, 79, 91, 109, 142, 177, 189 © Dreamstime")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Photographs on pages 38, 69, 76, 82, 113, 130, 138 © "), _c('a', {
    attrs: {
      "href": "http://istockphoto.com",
      "target": "_blank"
    }
  }, [_vm._v("istockphoto.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Photographs on pages 19, 27, 49, 89, 88, 101, 121, 127, 133, 153, 166 © Veer")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Printed in Canada")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("TCP")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("The paper used in this publication meets the minimum requirements of the American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials Z39.48-1992 (R1997).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.redwheelweiser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.redwheelweiser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.redwheelweiser.com/newsletter",
      "target": "_blank"
    }
  }, [_vm._v("www.redwheelweiser.com/newsletter")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a96ff83","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02copyright.vue
// module id = 63
// module chunks = 0